const TRACK_NEXT = 'TRACK/NEXT';
const TRACK_PREV = 'TRACK/PREV';
const TRACK_NEXT_IN_SEQUENCE = 'TRACK/TRACK_NEXT_IN_SEQUENCE';
const MODE_RANDOM = 'MODE/RANDOM';
const MODE_LOOP = 'MODE/LOOP';
const MODE_TRACK_DURATION = 'MODE/RACK_DURATION';
const MODE_TRACK_CURRENT_TIME = 'MODE/TRACK_CURRENT_TIME';
const MODE_VOLUME = 'MODE/VOLUME';

export {
  TRACK_NEXT, TRACK_PREV, TRACK_NEXT_IN_SEQUENCE, MODE_RANDOM, MODE_LOOP,
  MODE_TRACK_DURATION,
  MODE_TRACK_CURRENT_TIME,
  MODE_VOLUME,
};
